import { useQuery } from "react-query";
import { fetchBanks } from "../helpers/api";

const useBanks = () => {
  return useQuery(["get-banks"], fetchBanks, {
    select: (data) => data,
  });
};

export { useBanks };